module.exports = __webpack_public_path__ + "frontend/img/icon_info_text_transperent.f03aff25.svg";